import ICustomerBiometryPubsub from 'shared/domain/pubsubs/ICustomerBiometryPubsub';
import { makeWebSocketProvider } from 'shared/infra/providers';

import V1CustomerBiometryPubsub from './implementations/V1CustomerBiometryPubsub';

const PUBSUBS = {
  '1': V1CustomerBiometryPubsub,
} as const;

type TType = keyof typeof PUBSUBS;

const instances = new Map<TType, ICustomerBiometryPubsub>();

export default function makeCustomerBiometryPubsub({
  type = '1',
  unitId,
}: { type?: TType; unitId?: number } = {}) {
  if (!instances.has(type)) {
    const provider = makeWebSocketProvider({ unitId });

    const Implementation = PUBSUBS[type];

    instances.set(type, new Implementation(provider));
  }

  return instances.get(type) as ICustomerBiometryPubsub;
}
